import { Flex, VStack, Link, Spacer, Button } from '@telescope/cassini-ui';
import { AuthNav } from 'features';
import { useWidget } from '@telescope/cassini-hooks';
import { Open, Closed } from 'generated-types/widget';

export const TopContent = () => {
  const { data } = 
    useWidget({ select: (data: Open | Closed) => data.widget.global_views.rules });
  const { content: { rulesLink }, styles: { rulesLink: rulesLinkStyles } } = data!;

  return (
    <Flex w="100%" px={6} maxW="app">
      <Spacer />

      <VStack spacing={3}>
        <Button as={Link} href={rulesLink.url} isExternal {...rulesLinkStyles}
                variant="solidBold" borderRadius="full" fontSize="sm" px={4} py={2} height="auto">
          {rulesLink.copy}
        </Button>
        <AuthNav />
      </VStack>
    </Flex>
  )
}